import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import { HTMLtoJSX } from '../../../../../../helpers';
import { Text } from '../../styles';

export const HeroModuleText = ({ text, colorType, style }) => {
  const { location } = useSelector(selectPageConfig);

  return text ? (
    <Text className="formatted-text" colorType={colorType} style={style}>
      {HTMLtoJSX(text, location)}
    </Text>
  ) : null;
};

HeroModuleText.propTypes = {
  text: PropTypes.string,
  colorType: PropTypes.string,
};
